export default __webpack_public_path__ + "static/media/keyvis_text_dt@2x.9678c56d.png";